namespace advisorop.domains {
    "use strict";

    export interface IMeetingParticipant {
        id?: number;

        guid?: string;

        meetingId?: number;

        investorId?: number;

        advisorId?: number;

        name: string;

        isHost?: boolean;
    }
}